// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"Spinner_Spinner__BWqNs","load7":"Spinner_load7__3lEXz"};